import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function FeaturedProducts() {
  const allProducts = categories.flatMap((cat) => cat.products.slice(0, 2));

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
            精选推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            编辑严选欧美精品好物，每一件都经过精心挑选
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-product-shop>
          {allProducts.map((product) => (
            <div
              key={product.id}
              className="bg-background-50 rounded-lg overflow-hidden group cursor-pointer transition-colors hover:bg-background-50"
            >
              <div className="aspect-square overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-4">
                <p className="text-xs text-primary-600 font-medium mb-1">{product.brand}</p>
                <h3 className="font-heading text-sm font-medium text-foreground-900 mb-1.5 line-clamp-1">
                  {product.name}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 mb-3">{product.description}</p>
                <div className="flex items-center gap-2">
                  <span className="text-base font-semibold text-accent-600">{product.price}</span>
                  {product.originalPrice && (
                    <span className="text-xs text-foreground-400 line-through">{product.originalPrice}</span>
                  )}
                </div>
                <div className="mt-2 flex flex-wrap gap-1">
                  {product.tags.map((tag) => (
                    <span key={tag} className="text-[10px] px-2 py-0.5 rounded-full bg-background-100 text-foreground-500">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-8">
          <Link
            to="/categories"
            className="inline-block px-6 py-2.5 rounded-full bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部精选
          </Link>
        </div>
      </div>
    </section>
  );
}